//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(() => {
    const angular = window['angular'];
    const _ = window['_'];
    const moment = window['moment'];
    const curalate = angular.module('curalate');

    interface IClientFeaturesChangelogScope extends angular.IScope {
        clientId: string,
        model: ClientFeaturesChangelogModel
    };

    class ClientFeaturesChangelogModel {
        changes: Array<IClientFeatureChangeDTO> = [];
        outstandingAsyncAction?: string = null;
        activeTableParams: any;
        errorMessage?: string = null;
        reloadTable: () => void;
        formatTimestamp: (string) => string;
        updateDateParam: (any?) => void;
        changeMade: boolean = true;
        start: string = '';
        end: string = '';
        constructor(
            activeTableParams: any,
            reloadTable: () => void,
            formatTimestamp: (string) => string,
            updateDateParam: (any?) => void
        ) {
            this.activeTableParams = activeTableParams;
            this.reloadTable = reloadTable;
            this.formatTimestamp = formatTimestamp;
            this.updateDateParam = updateDateParam;
        }
    };

    curalate.directive('clientFeaturesChangelog', [
        'DateTimeService',
        'FeaturesService',
        'SweetAlert',
        'ngClientSideTableParams',
        (
            DateTimeService,
            FeaturesService,
            SweetAlert,
            ngClientSideTableParams
        ) => {
            return {
                restrict: 'E',
                scope: {
                    clientId: '@'
                },
                templateUrl: '/app/components/features/client-features-changelog/client-features-changelog.html',
                link: (scope: IClientFeaturesChangelogScope) => {

                    const isValidDate = (dateString: string) => {
                        return moment(dateString, 'YYYY-MM-DD', true).isValid();
                    };

                    const activeTableParams = new ngClientSideTableParams({
                        tableName: 'ClientFeaturesChangelog',
                        sorting: { },
                        total: 1
                    }, {
                        getData($defer, params) {
                            if (!isValidDate(scope.model.start) || !isValidDate(scope.model.end)) {
                                scope.model.errorMessage = 'Please make sure your start and end date in a valid format! (YYYY-MM-DD)';
                                return;
                            }
                            scope.model.changeMade = false;

                            scope.model.outstandingAsyncAction = 'loadingChangelog';
                            FeaturesService.getClientChangelogAsync(
                                scope.clientId,
                                scope.model.start,
                                scope.model.end
                            ).then((result: Array<IClientFeatureChangeDTO>)  => {
                                scope.model.changes = result;
                                params.count(result.length);
                                // Because sortable can't sort a nested object
                                $defer.resolve(scope.model.changes);
                            }).catch(error => {
                                SweetAlert.alert({
                                    title: 'Failed to fetch client feature changes.',
                                    text: error,
                                });
                            }).finally(() => {
                                scope.model.outstandingAsyncAction = null;
                            });
                        },
                    });

                    const reloadTable = () => {
                        scope.model.errorMessage = null;
                        activeTableParams.reload();
                    };

                    const formatTimestamp = (timestamp: string): string => {
                        return moment(timestamp).format('YYYY-MM-DD hh:mm:ss A');
                    };

                    const updateDateParam = ($event?: any) => {
                        scope.model.changeMade = true;
                        if (!$event || $event.which === 13) {
                            reloadTable();
                        }
                    };

                    scope.model = new ClientFeaturesChangelogModel(
                        activeTableParams,
                        reloadTable,
                        formatTimestamp,
                        updateDateParam
                    );

                    const onInit = () => {
                        const defaultDateRange = DateTimeService.getDateRangeFromIdentifier(DateTimeService.DateRangeConstants.LAST_30_DAYS, true);
                        scope.model.start = defaultDateRange.from.format('YYYY-MM-DD');
                        scope.model.end = defaultDateRange.to.format('YYYY-MM-DD');
                    };

                    onInit();
                }
            };
        }
    ]);
})();
